import React from 'react';
import {makeStyles} from "@mui/styles/";
const useStyles = makeStyles({
    storeText: {
   //  color: customTheme.light.dark,
     fontWeight: "bold",
     marginLeft: 10,
     textDecorationLine: "underline",
     fontSize: 16,
   },
 });
const StoreImage = ({image ,textStyle , storeID})=>{
    const styles =useStyles();
    return <div> 
    {!!image && image != '' && <img alt="storeImage" src={image} style={{ width: 60, height: 60, resizeMode: 'contain' }} />}
    </div>;
}


  

  export default StoreImage;